import script from "./Dato2Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Dato2Form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__